export const CONNECTION_KEY = 'Connection';
